import { PLACES } from './data';
import { REGIONS } from './expansion';

export const SAVE_STATIONS = [...PLACES.slice(1), ...REGIONS].map(p => ({ id: `save-${p.id}`, name: `${p.name} save station`, x: p.x + (p.id === 'checkered-picnic' ? -4 : 4), z: p.z + (p.id === 'rainwater-canal' ? 12 : 2) }));
